<template>
  <div>
    <div v-wechat-title='"新春仙二「余情」特别服预约开启！"'></div>
    <div class="appoint-pc-page">
      <div class="logo"></div>
      <div class="title"></div>
      <div class="main"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp } from '@/utils/utils';
export default {
  components: {},
  data() {
    return {
    };
  },
  created() { },
  mounted() {
    this.$nextTick(() => {
      this.monitoringEquipment();
    });
  },
  computed: {},
  methods: {
    monitoringEquipment() {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `https://h5.qingcigame.com/hjwq/newArea-appoint/enter${getTimeStamp()}`
      }
    }
  }
};
</script>

<style lang="less">
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/newArea-appoint/pc/index.vue